import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { provideRouter, withComponentInputBinding } from "@angular/router";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { QuillModule } from "ngx-quill";

import { routes } from "./app.routes";
import { HttpBearerTokenInterceptor } from "./shared/http";
import { initializeApplication } from "./app.initializer";
import { UserContext } from "./contexts";
import { registerLocaleData } from "@angular/common";
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      SweetAlert2Module.forRoot(),
      FontAwesomeModule,
      QuillModule.forRoot()
    ),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpBearerTokenInterceptor,
      multi: true
    },
    provideAppInitializer(() => {
      const initializerFn = (initializeApplication)(inject(UserContext));
      return initializerFn();
    }),
  ]
};
